import React, { useState, useEffect } from "react";
import { Button, Input, Label } from "reactstrap";
import rightIcon from "../../assets/icon/pagination-right.svg";
import leftIcon from "../../assets/icon/pagination-left.svg";
import endIcon from "../../assets/icon/pagination-end.svg";
import firstIcon from "../../assets/icon/pagination-first.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { singleArrow } from "../../assets/icon/single-down-arrow.svg";
import ReactInputMask from "react-input-mask";

const Pagination = ({
  currentPage,
  totalRecords,
  onPageChange,
  pageSize,
  hasNoEligibility = true,
  researchNeededCount,
  eligibleCount,
  inEligibleCount,
}) => {
  const [state, setState] = useState({
    value: "",
    error: "",
  });
  const [selectedOption, setSelectedOption] = useState("");

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };
  useEffect(() => {
    setState((pre) => ({ ...pre, value: currentPage }));
  }, [currentPage]);

  const getTotalPage = (total, pageSize) => {
    const totalPage = total / pageSize;
    const page = Math.floor(total / pageSize);
    const splitted = totalPage.toString().split(".");
    if (splitted[1]) {
      return page + 1;
    } else {
      return page;
    }
  };

  const onPageNext = (value) => {
    switch (value) {
      case "NEXT":
        const page = currentPage + 1;
        if (page <= getTotalPage(totalRecords, pageSize)) {
          setState((pre) => ({ ...pre, value: page }));
          return onPageChange(page);
        }
        break;
      case "PREVIOUS":
        const previousPage = currentPage - 1;
        if (previousPage >= 1) {
          setState((pre) => ({ ...pre, value: previousPage }));
          return onPageChange(previousPage);
        }
        break;
      default:
        break;
    }
  };

  const onInputChange = (e) => {
    const { value } = e.target;
    if (parseInt(value) === 0)
      return setState((pre) => ({
        ...pre,
        value,
        error: "Enter proper Page number",
      }));
    if (value === "")
      return setState((pre) => ({
        ...pre,
        value: "",
        error: "Enter proper Page number",
      }));
    if (value > getTotalPage(totalRecords, pageSize))
      return setState((pre) => ({
        ...pre,
        value,
        error: "Enter proper Page number",
      }));
    setState((pre) => ({ ...pre, value, error: "" }));
  };

  const onKeyEnterPage = (e) => {
    const { key } = e;
    const { value, error } = state;
    if (key === "Enter" && !error) {
      onPageChange(parseInt(value));
    }
  };
  const handlePageSizeChange = (e, filters, isHaveColFilter) => {
    const { value } = e.target;
    const pageFilter = {
      ...filters,
      currentPage: 1,
      pageSize: parseInt(value),
    };
    if (isHaveColFilter) {
      let colFilterOn = { ...pageFilter, filters: columnFilters };
      return onPageChange(colFilterOn, true, columnChangedFilters);
    }
    onPageChange(pageFilter);
  };

  // const handlePageSizeChange= (e)=>{
  //   const {value}= e.target
  //   setItemsperPage(value)
  // }
  // console.log(iemsperpage)

  return (
    <div className="d-flex justify-content-between align-items-center rcm-pagination">
      <div className="d-flex align-items-center">
        <div className="">
          <span className="text-danger">{state.error}</span>
        </div>

        <div hidden={hasNoEligibility}>
          <span>Research Required : </span> {researchNeededCount} &nbsp;&nbsp;
          <span>Eligible : </span> {eligibleCount} &nbsp;&nbsp;
          <span>Ineligible : </span> {inEligibleCount} &nbsp;&nbsp;
        </div>

        {/* <Button
          disabled={currentPage === 1 || totalRecords === 0}
          onClick={() => onPageChange(1)}
          color="link"
          className="px-0"
        >
          <img src={firstIcon} alt="firstIcon" />
        </Button> */}
        <div className="Pagination_list">
          <Button
            disabled={currentPage === 1 || totalRecords === 0}
            onClick={() => onPageNext("PREVIOUS")}
            color="link"
            className=""
          >
            {/* <img src={leftIcon} alt="leftIcon" /> */}
            <FontAwesomeIcon icon={faAngleLeft} className="fa-fw" />
          </Button>
        </div>
        <div>
          {/* <Input
            type="number"
            value={state.value}
            onChange={onInputChange}
            className="mx-2"
            onKeyDown={onKeyEnterPage}
            disabled={totalRecords === 0}
          /> */}
        </div>
        <div className="font-size-16 pe-2">
          <ul className="Pagination_list">
            <li className="active">1</li>
            <li>2</li>
            <li>3</li>

            <li>....</li>
            {/* <li>{getTotalPage(totalRecords, pageSize)}</li> */}
            <li>100</li>
          </ul>
          <span>{/* {getTotalPage(totalRecords, pageSize)} */}</span>
          <span>{/* ({totalRecords}) */}</span>
        </div>
        <div className="Pagination_list">
          <Button
            color="link"
            disabled={
              currentPage === getTotalPage(totalRecords, pageSize) ||
              totalRecords === 0
            }
            onClick={() => onPageNext("NEXT")}
            className="px-0"
          >
            {/* <img src={rightIcon} /> */}
            <FontAwesomeIcon icon={faAngleRight} className="fa-fw" />
          </Button>
        </div>

        {/* <Button
          disabled={currentPage === getTotalPage(totalRecords, pageSize) || totalRecords === 0}
          onClick={() => onPageChange(getTotalPage(totalRecords, pageSize))}
          color="link"
          className="px-0"
        >
          <img src={endIcon} />
        </Button> */}
      </div>
      <div className="count-box">
        <span className="pagination-text">Records Per Page</span>
        <Input
               type='select'
               // onChange={handlePageSizeChange}
               bsSize='sm'
               className='display-select d-inline-block'
               value={pageSize}
             >
               <option value={10}>10</option>
               <option value={25}>25</option>
               <option value={50}>50</option>
               <option value={100}>100</option>
             </Input> 
             
        {/* <div className="count-arrow-alignment">
          <select className="cursor-pointer">
            <option>5</option>
            <option>10</option>
            <option>15</option>
            <option>20</option>
            <option>25</option>
          </select>{" "}
        </div> */}
        {/* <select
          value={selectedOption}
          onChange={handleChange}
          style={{
            backgroundColor: "white",
            borderRadius: "4px",
            fontSize: "16px",
            fontWeight: "500",
          }}
          className="display-select d-inline-block"
        >
          <option value="">5</option>
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="25">25</option>
        </select> */}
      </div>
    </div>
  );
};

export default Pagination;
